import React from 'react';
import PropTypes from 'prop-types';
import Label from './Label';

function FieldTemplate(props) {
  const {
    id,
    classNames,
    label,
    children,
    errors,
    help,
    description,
    hidden,
    required,
    displayLabel,
    hint,
    schema,
  } = props;

  if (hidden) {
    return <span />;
  }

  const shouldHideFields = schema.displayOnly;
  const displayHint = hint || schema.hint;
  return (
    <div className={classNames}>
      {displayLabel && !shouldHideFields && <Label label={label} required={required} id={id} />}
      {displayLabel && description && !shouldHideFields ? description : null}
      {displayHint && !shouldHideFields ? <p className="form__hint">{displayHint}</p> : null}
      {children}
      {errors}
      {help}
    </div>
  );
}

if (process.env.NODE_ENV !== 'production') {
  FieldTemplate.propTypes = {
    id: PropTypes.string, // eslint-disable-line
    classNames: PropTypes.string, // eslint-disable-line
    label: PropTypes.string, // eslint-disable-line
    children: PropTypes.node.isRequired,
    errors: PropTypes.element, // eslint-disable-line
    rawErrors: PropTypes.arrayOf(PropTypes.string), // eslint-disable-line
    help: PropTypes.element, // eslint-disable-line
    rawHelp: PropTypes.oneOfType([PropTypes.string, PropTypes.element]), // eslint-disable-line
    description: PropTypes.element, // eslint-disable-line
    rawDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.element]), // eslint-disable-line
    hidden: PropTypes.bool,
    required: PropTypes.bool,
    readonly: PropTypes.bool, // eslint-disable-line
    displayLabel: PropTypes.bool,
    fields: PropTypes.object, // eslint-disable-line
    formContext: PropTypes.object, // eslint-disable-line
  };
}

FieldTemplate.defaultProps = {
  hidden: false,
  readonly: false,
  required: false,
  displayLabel: true,
};

export default FieldTemplate;



// WEBPACK FOOTER //
// ./src/byob-cms/src/AppLib/formLib/FieldTemplate.js